import { Api } from "../api";
import { IClientCompany, IUpdateClientCompany } from "shared/protocolos";

type TClientCompanyList = {
    data: IClientCompany[];
    totalCount: number;
};

const getAll = async (filter = "", page = 1, limit = 10): Promise<TClientCompanyList | Error> => {
    try {
        const params = new URLSearchParams({
            like: filter,
            page: String(page),
            limit: String(limit),
        });
        const url = `/client-company?${params.toString()}`;

        const { data } = await Api.get(url);

        if (data) {
            return {
                data: data.data,
                totalCount: data.count,
            };
        }

        return new Error("Erro ao listar registros.");
    } catch (error) {
        return new Error((error as { message: string }).message || "Erro ao listar registros.");
    }
};

const getAllByUser = async (userId: string): Promise<IClientCompany[] | Error> => {
    try {
        const url = `/client-company/user/${userId}`;

        const { data } = await Api.get(url);

        if (data) {
            return data
        }

        return new Error("Erro ao listar registros.");
    } catch (error) {
        return new Error((error as { message: string }).message || "Erro ao listar registros.");
    }
};

const getById = async (id: string): Promise<IClientCompany | Error> => {
    try {
        const { data } = await Api.get(`/client-company/${id}`);

        if (data) {
            return data;
        }

        return new Error("Registro não encontrado.");
    } catch (error) {
        return new Error((error as { message: string }).message || "Erro ao consultar registro.");
    }
};

const create = async (dataToSave: Omit<IClientCompany, "id" | "createdAt" | "updatedAt">): Promise<string | Error> => {
    try {
        const { data } = await Api.post<IClientCompany>("/client-company", dataToSave);

        if (data) {
            return data.id;
        }

        return new Error("Erro ao criar registro.");
    } catch (error) {
        return new Error((error as { message: string }).message || "Erro ao criar registro.");
    }
};

const updateById = async (id: string, dataToUpdate: IUpdateClientCompany): Promise<void | Error> => {
    try {
        await Api.put(`/client-company/${id}`, dataToUpdate);
    } catch (error) {
        return new Error((error as { message: string }).message || "Erro ao atualizar registro.");
    }
};

const deleteById = async (id: string, userId: string): Promise<void | Error> => {
    try {
        await Api.delete(`/client-company/${id}/${userId}`);
    } catch (error) {
        return new Error((error as { message: string }).message || "Erro ao apagar registro.");
    }
};

export const ClientCompanyService = {
    getAll,
    getAllByUser,
    getById,
    create,
    updateById,
    deleteById,
};
